// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__xHB-0","author":"Table_author__1tzr3","authorImage":"Table_authorImage__1QNWC","unreadRow":"Table_unreadRow__3VBpu"};